module.exports = __webpack_public_path__ + "img/soluble.9f1e1f5c.png";